import { render, staticRenderFns } from "./SpecialitiesFragment.vue?vue&type=template&id=736ad24f"
import script from "./SpecialitiesFragment.vue?vue&type=script&lang=js"
export * from "./SpecialitiesFragment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports